// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Created: 8/14/2019, 11:27:59 AM
// Hash: 93130294
// </auto-generated>
export enum Direction {
  inbound = 1,
  outbound = 2,
}
